import React, { useContext, useEffect, useRef, useState } from 'react';
import { AppContext } from '../App';
import { classIf } from '../data/utils/classIf';
import { scrollToTarget } from '../data/utils/scrollToTarget';
import { labels } from '../data/labels';
import { LiveMatchContext } from '../live/match/LiveMatchDataFetcher';
import { isOverlaySection } from '../utils/sport-effects';

function AggregataSelector(props) {
    const [expanded, setExpanded] = useState(false);
    const appContext = useContext(AppContext);
    const liveMatchContext = React.useContext(LiveMatchContext);
    const context = liveMatchContext;

    function toggleExpand() {
        setExpanded(!expanded);
        if (expanded) {
            setTimeout(() => {
                if (navbar.current) {
                    const selected = navbar.current.querySelector('.selected');
                    scrollToTarget(navbar.current, selected);
                }
            }, 200);
        }
    }

    function toggleFavorites() {
        context.favoriteMarketsOn();
    }

    const navbar = useRef(null);
    useEffect(() => {
        if (navbar.current && !context) {
            const selected = navbar.current.querySelector('.selected');
            if (selected && navbar.current.firstElementChild !== selected) {
                navbar.current.scrollLeft = selected.getBoundingClientRect().left;
            }
        }
    }, []);

    const hideWrapper = isOverlaySection(appContext,props.section);
    const favoritesMarketsSelected = context && context.favoritesSelected;

    return (
        <nav className={"nav-filters-wrapper"  + classIf(hideWrapper, 'd-none')}>
            <div className={"nav-filters" + classIf(expanded, 'expanded')} ref={navbar}>
                {(context && context.showFavoritesForSport(context.match.sportRef)) &&
                    <div className={"nav-filter-item" + classIf(favoritesMarketsSelected, 'selected')} onClick={toggleFavorites}>{labels['favorite_markets']}</div>
                }
                {props.betGroups && props.betGroups.map(bg => {
                    function handleClick(e) {
                        props.changeBetGroup(bg.idAggregata);
                        if (expanded) {
                            setExpanded(!expanded);
                            setTimeout(() => {
                                if (navbar.current) {
                                    scrollToTarget(navbar.current, e.target);
                                }
                            }, 200);
                        }
                    }
                    return <div key={bg.idAggregata} className={"nav-filter-item" + classIf(!favoritesMarketsSelected && bg.idAggregata === props.aggregata, 'selected')} onClick={handleClick}>{bg.descrizione}</div>
                })}
                {expanded &&
                    <div className="nav-filters-close-button" onClick={toggleExpand}>
                        <i className="far fa-times-circle"></i>
                    </div>
                }
            </div>
            {props.betGroups && props.betGroups.length > 3 &&
                <div className="nav-filters-expand-button" onClick={toggleExpand}>
                    <i className="fa fa-angle-down"></i>
                </div>
            }
        </nav>
    );
}

export default AggregataSelector;